
import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError, tap } from 'rxjs/operators';

import * as SportActions from '../actions/sport.actions';
import { SportService } from '../../services/sport.service';

@Injectable({ providedIn: 'root' })
export class SportEffects {
    private sportService = inject(SportService);
    private actions$ = inject(Actions);

    loadSports$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SportActions.loadSports),
            switchMap(() =>
                this.sportService.getSports().pipe(
                    map(sports => SportActions.loadSportsSuccess({ sports })),
                    catchError(error => of(SportActions.loadSportsFailure({ error })))
                )
            )
        )
    );

    loadSportsSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(SportActions.loadSportsSuccess),
                tap(({ sports }) => {
                })
            ),
        { dispatch: false }
    );

    loadSportsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(SportActions.loadSportsFailure),
                tap(({ error }) => {
         
                })
            ),
        { dispatch: false }
    );
}